export default __webpack_public_path__ + "static/image-41-37e07646099de2f602c1de9e9742321e.jpg";